import React from 'react';
import PropTypes from 'prop-types';

const Company = ({ authInfo }) => (
  <div className="account">
    <p title={`${authInfo.getGroupId()}-${authInfo.getCompanyId()}`}>
      {authInfo.getCompanyName()} ({authInfo.getGroupId()} - {authInfo.getCompanyId()})
    </p>
  </div>
);

Company.propTypes = {
  authInfo: PropTypes.object.isRequired,
};

export default Company;
